export default {"src":"/_next/static/media/holdMoney_40.6598ef54.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};